module.exports = __webpack_public_path__ + "img/badges2.700d4bcd.png";